import { render, staticRenderFns } from "./vEdit.vue?vue&type=template&id=5ea4d436&scoped=true&"
import script from "./vEdit.vue?vue&type=script&lang=js&"
export * from "./vEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4d436",
  null
  
)

export default component.exports